import React from 'react';
import T from 'prop-types';

const Context = React.createContext();

export const { Consumer } = Context;

export const Provider = ({ children }) => {
  const audioEl = React.useRef();
  const [playing, setPlaying] = React.useState(false);
  const [source, setSource] = React.useState();

  const handlePlaying = React.useCallback(() => {
    setPlaying(true);
    setSource(audioEl.current.src);
  }, [setPlaying, setSource]);

  const handleStopped = React.useCallback(() => {
    setPlaying(false);
  }, [setPlaying]);

  const onPlay = React.useCallback(src => {
    audioEl.current.src = src;
    audioEl.current.play();
  }, []);

  const onStop = React.useCallback(() => {
    audioEl.current.pause();
    audioEl.current.currentTime = 0;
  }, []);

  React.useEffect(() => {
    const { current: audioElement } = audioEl;
    audioElement.addEventListener('play', handlePlaying);
    audioElement.addEventListener('pause', handleStopped);

    return () => {
      audioElement.removeEventListener('play', handlePlaying);
      audioElement.removeEventListener('pause', handleStopped);
    };
  }, [handlePlaying, handleStopped]);

  return (
    <div>
      <audio ref={audioEl} />
      <Context.Provider
        value={{
          playing,
          onPlay,
          onStop,
          src: source,
        }}
      >
        {children}
      </Context.Provider>
    </div>
  );
};

Provider.propTypes = {
  children: T.node,
};

export default Context;
